import { nullifyTransforms } from "./helpers"
import { getDimensionFor, getLeftOrTop } from "./direction-helpers"

export const renderPillsFor = (flexyInstance) => {
  if (!flexyInstance.options.pillsContainerSelector) return
  flexyInstance.options.pillsContainerSelector.querySelector(".active") &&
    flexyInstance.options.pillsContainerSelector
      .querySelector(".active")
      .classList.remove("active")

  flexyInstance.options.pillsContainerSelector.children[
    flexyInstance.state.previousCurrentIndex
  ].classList.add("active")

  if (flexyInstance.options.pillsFlexyInstance) {
    let localFlexyInstance = flexyInstance.options.pillsFlexyInstance.flexy
    let allPills = [...flexyInstance.options.pillsContainerSelector.children]

    let fromIndex = [...localFlexyInstance.sliderContainer.children].indexOf(
      [...localFlexyInstance.sliderContainer.children].reduce(
        (leftmostEl, currentEl) => {
          let left = getLeftOrTop(
            nullifyTransforms(
              leftmostEl,
              localFlexyInstance.options.nullifyTransformEl
            ),
            localFlexyInstance
          )

          let currentLeft = getLeftOrTop(
            nullifyTransforms(
              currentEl,
              localFlexyInstance.options.nullifyTransformEl
            ),
            localFlexyInstance
          )

          return Math.abs(
            currentLeft -
              getLeftOrTop(
                nullifyTransforms(
                  localFlexyInstance.sliderContainer,
                  localFlexyInstance.options.nullifyTransformEl
                ),
                localFlexyInstance
              )
          ) <
            Math.abs(
              left -
                getLeftOrTop(
                  nullifyTransforms(
                    localFlexyInstance.sliderContainer,
                    localFlexyInstance.options.nullifyTransformEl
                  ),
                  localFlexyInstance
                )
            )
            ? currentEl
            : leftmostEl
        },
        {
          getBoundingClientRect: () => ({
            left: 100000000000,
            top: 100000000000,
          }),
        }
      )
    )

    let toIndex = 0

    if (localFlexyInstance.options.orientation === "horizontal") {
      let perPage = Math.round(
        nullifyTransforms(localFlexyInstance.sliderContainer).width /
          nullifyTransforms(
            localFlexyInstance.sliderContainer.firstElementChild
          ).width
      )

      toIndex = flexyInstance.state.previousCurrentIndex

      if (perPage === 5) {
        if (flexyInstance.state.previousCurrentIndex > 2) {
          toIndex = flexyInstance.state.previousCurrentIndex - 2
        }

        if (
          allPills.length - 1 - flexyInstance.state.previousCurrentIndex <
          3
        ) {
          toIndex = allPills.length - 5
        }
      }

      if (perPage === 3) {
        if (flexyInstance.state.previousCurrentIndex >= 1) {
          toIndex = flexyInstance.state.previousCurrentIndex - 1
        }

        if (
          allPills.length - 1 - flexyInstance.state.previousCurrentIndex <
          1
        ) {
          toIndex = allPills.length - 3
        }
      }
    } else {
      toIndex = flexyInstance.state.previousCurrentIndex
    }

    let amountToTheLeft = Math.abs(toIndex - fromIndex)
    let amountToTheRight =
      Math.min(fromIndex, toIndex) +
      (allPills.length - Math.max(fromIndex, toIndex))

    let p =
      Math.min(amountToTheLeft, amountToTheRight) *
      (amountToTheRight >= amountToTheLeft
        ? fromIndex > toIndex
          ? 1
          : -1
        : fromIndex > toIndex
        ? -1
        : 1)

    let resultTarget =
      (Math.round(
        (localFlexyInstance.state.positionX * 100) /
          getDimensionFor(
            nullifyTransforms(
              localFlexyInstance.sliderContainer.firstElementChild,
              localFlexyInstance.options.nullifyTransformEl
            ),
            localFlexyInstance
          ) /
          100
      ) *
        100 *
        getDimensionFor(
          nullifyTransforms(
            localFlexyInstance.sliderContainer.firstElementChild,
            localFlexyInstance.options.nullifyTransformEl
          ),
          localFlexyInstance
        )) /
        100 +
      getDimensionFor(
        nullifyTransforms(
          localFlexyInstance.sliderContainer.firstElementChild,
          localFlexyInstance.options.nullifyTransformEl
        ),
        localFlexyInstance
      ) *
        p

    localFlexyInstance.state = {
      ...localFlexyInstance.state,
      positionTarget: resultTarget,
    }
  }
}

export const mountPillsListeners = (flexyInstance) => {
  if (!flexyInstance.options.pillsContainerSelector) return

  let allPills = [...flexyInstance.options.pillsContainerSelector.children]

  const handlePillEvent = (singlePill) => {
    let fromIndex = [...flexyInstance.sliderContainer.children].indexOf(
      [...flexyInstance.sliderContainer.children].reduce(
        (leftmostEl, currentEl) => {
          let left = getLeftOrTop(
            nullifyTransforms(
              leftmostEl,
              flexyInstance.options.nullifyTransformEl
            ),
            flexyInstance
          )

          let currentLeft = getLeftOrTop(
            nullifyTransforms(
              currentEl,
              flexyInstance.options.nullifyTransformEl
            ),
            flexyInstance
          )

          return Math.abs(
            currentLeft -
              getLeftOrTop(
                nullifyTransforms(
                  flexyInstance.sliderContainer,
                  flexyInstance.options.nullifyTransformEl
                ),
                flexyInstance
              )
          ) <
            Math.abs(
              left -
                getLeftOrTop(
                  nullifyTransforms(
                    flexyInstance.sliderContainer,
                    flexyInstance.options.nullifyTransformEl
                  ),
                  flexyInstance
                )
            )
            ? currentEl
            : leftmostEl
        },
        {
          getBoundingClientRect: () => ({
            left: 100000000000,
          }),
        }
      )
    )

    let toIndex = allPills.indexOf(singlePill)

    flexyInstance.options.pillsContainerSelector.querySelector(".active") &&
      flexyInstance.options.pillsContainerSelector
        .querySelector(".active")
        .classList.remove("active")

    singlePill.classList.add("active")

    let amountToTheLeft = Math.abs(toIndex - fromIndex)
    let amountToTheRight =
      Math.min(fromIndex, toIndex) +
      (allPills.length - Math.max(fromIndex, toIndex))

    let p =
      Math.min(amountToTheLeft, amountToTheRight) *
      (amountToTheRight >= amountToTheLeft
        ? fromIndex > toIndex
          ? 1
          : -1
        : fromIndex > toIndex
        ? -1
        : 1)

    let resultTarget =
      (Math.round(
        (flexyInstance.state.positionX * 100) /
          getDimensionFor(
            nullifyTransforms(
              flexyInstance.sliderContainer.firstElementChild,
              flexyInstance.options.nullifyTransformEl
            ),
            flexyInstance
          ) /
          100
      ) *
        100 *
        getDimensionFor(
          nullifyTransforms(
            flexyInstance.sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )) /
        100 +
      getDimensionFor(
        nullifyTransforms(
          flexyInstance.sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      ) *
        p

    flexyInstance.state = {
      ...flexyInstance.state,
      positionTarget: resultTarget,
    }
  }

  if (
    flexyInstance.options.initialDragEvent &&
    flexyInstance.options.initialDragEvent.target.closest(
      ".flexy-pills > * > *"
    )
  ) {
    setTimeout(() => {
      handlePillEvent(
        flexyInstance.options.initialDragEvent.target.closest(
          ".flexy-pills > * > *"
        )
      )
    })
  }

  allPills.map((singlePill) =>
    singlePill.addEventListener("click", (e) => {
      handlePillEvent(singlePill)
      e.preventDefault()
    })
  )
}
